import { Box } from "@carrotfertility/carotene-core"
import { CenteredLoadingIndicator } from "../molecules/Molecules"
import React from "react"

export function RegisteringLoadingIndicator(): JSX.Element {
  return (
    <Box display="flex" alignItems="center" justifyContent="center" height="100vh">
      <CenteredLoadingIndicator />
    </Box>
  )
}
